export default __webpack_public_path__ + "static/media/human.0a426d26.png";